import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "admin-nav" }
const _hoisted_2 = { class: "admin-nav-right" }
const _hoisted_3 = {
  class: "admin-nav-bell",
  type: "button",
  "aria-label": "Notificacoes"
}
const _hoisted_4 = {
  key: 0,
  class: "bell-badge"
}
const _hoisted_5 = {
  key: 0,
  class: "bell-empty"
}
const _hoisted_6 = { class: "bell-item-title" }
const _hoisted_7 = { class: "bell-item-meta" }
const _hoisted_8 = {
  key: 0,
  class: "bell-item-message"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "admin-nav-user-group" }
const _hoisted_11 = { class: "admin-nav-avatar" }
const _hoisted_12 = { class: "admin-nav-username" }
const _hoisted_13 = { class: "cpw-modal" }
const _hoisted_14 = { class: "cpw-field" }
const _hoisted_15 = { class: "cpw-field" }
const _hoisted_16 = { class: "cpw-field" }
const _hoisted_17 = {
  key: 0,
  class: "cpw-error"
}
const _hoisted_18 = {
  key: 1,
  class: "cpw-success"
}
const _hoisted_19 = { class: "cpw-actions" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "pal-box" }
const _hoisted_22 = { class: "pal-search" }
const _hoisted_23 = { class: "pal-results" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "pal-name" }
const _hoisted_26 = { class: "pal-user" }
const _hoisted_27 = {
  key: 0,
  class: "pal-badge"
}
const _hoisted_28 = {
  key: 0,
  class: "pal-empty"
}
const _hoisted_29 = { class: "admin-kpis" }
const _hoisted_30 = { class: "kpi" }
const _hoisted_31 = { class: "kpi-value" }
const _hoisted_32 = { class: "kpi" }
const _hoisted_33 = { class: "kpi-value kpi-value--ok" }
const _hoisted_34 = { class: "kpi" }
const _hoisted_35 = { class: "kpi" }
const _hoisted_36 = { class: "kpi-value" }
const _hoisted_37 = { class: "kpi" }
const _hoisted_38 = { class: "kpi-value" }
const _hoisted_39 = { class: "kpi kpi--storage" }
const _hoisted_40 = { class: "kpi-storage-top" }
const _hoisted_41 = { class: "kpi-value" }
const _hoisted_42 = { class: "kpi-storage-of" }
const _hoisted_43 = { class: "kpi-storage-bar" }
const _hoisted_44 = { class: "admin-cmdbar" }
const _hoisted_45 = { class: "admin-pivot" }
const _hoisted_46 = { class: "admin-cmdbar-actions" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "admin-main" }
const _hoisted_49 = { class: "admin-content-inner" }
const _hoisted_50 = { class: "admin-search-wrap" }
const _hoisted_51 = {
  key: 0,
  class: "admin-loading"
}
const _hoisted_52 = {
  key: 1,
  class: "admin-grid"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "obra-card-name" }
const _hoisted_55 = { class: "obra-card-body" }
const _hoisted_56 = { class: "obra-stat-row" }
const _hoisted_57 = { class: "obra-stat" }
const _hoisted_58 = { class: "obra-stat-value" }
const _hoisted_59 = { class: "obra-stat" }
const _hoisted_60 = { class: "obra-stat-value" }
const _hoisted_61 = { class: "obra-stat" }
const _hoisted_62 = { class: "obra-stat-value" }
const _hoisted_63 = { class: "obra-storage" }
const _hoisted_64 = { class: "obra-storage-bar-wrap" }
const _hoisted_65 = { class: "obra-storage-label" }
const _hoisted_66 = { class: "obra-dates" }
const _hoisted_67 = { class: "obra-date-item" }
const _hoisted_68 = { class: "obra-date-value" }
const _hoisted_69 = { class: "obra-date-item" }
const _hoisted_70 = { class: "obra-date-value" }
const _hoisted_71 = ["disabled", "onClick"]
const _hoisted_72 = { class: "analytics-subtabs" }
const _hoisted_73 = {
  key: 0,
  class: "admin-loading"
}
const _hoisted_74 = {
  key: 1,
  class: "analytics-wrap"
}
const _hoisted_75 = { class: "analytics-cards" }
const _hoisted_76 = { class: "acard" }
const _hoisted_77 = { class: "acard-value" }
const _hoisted_78 = { class: "acard" }
const _hoisted_79 = { class: "acard-value" }
const _hoisted_80 = { class: "acard acard-warn" }
const _hoisted_81 = { class: "acard-value" }
const _hoisted_82 = { class: "acard" }
const _hoisted_83 = { class: "acard-value" }
const _hoisted_84 = { class: "acard" }
const _hoisted_85 = { class: "acard-value" }
const _hoisted_86 = { class: "acard" }
const _hoisted_87 = { class: "acard-value" }
const _hoisted_88 = { class: "acard" }
const _hoisted_89 = { class: "acard-value" }
const _hoisted_90 = { class: "analytics-cols" }
const _hoisted_91 = { class: "analytics-panel" }
const _hoisted_92 = { class: "rank-list" }
const _hoisted_93 = ["onClick"]
const _hoisted_94 = { class: "rank-num" }
const _hoisted_95 = { class: "rank-name" }
const _hoisted_96 = { class: "rank-val" }
const _hoisted_97 = { class: "analytics-panel" }
const _hoisted_98 = { class: "rank-list" }
const _hoisted_99 = ["onClick"]
const _hoisted_100 = { class: "rank-num" }
const _hoisted_101 = { class: "rank-name" }
const _hoisted_102 = { class: "rank-val" }
const _hoisted_103 = { class: "analytics-panel" }
const _hoisted_104 = {
  key: 0,
  class: "rank-empty"
}
const _hoisted_105 = { class: "rank-list" }
const _hoisted_106 = ["onClick"]
const _hoisted_107 = { class: "rank-name" }
const _hoisted_108 = { class: "rank-val" }
const _hoisted_109 = {
  key: 0,
  class: "admin-loading"
}
const _hoisted_110 = {
  key: 1,
  class: "storage-wrap"
}
const _hoisted_111 = { class: "analytics-cards" }
const _hoisted_112 = { class: "acard" }
const _hoisted_113 = { class: "acard-value" }
const _hoisted_114 = { class: "acard" }
const _hoisted_115 = { class: "acard-value" }
const _hoisted_116 = { class: "acard-value" }
const _hoisted_117 = { class: "acard" }
const _hoisted_118 = { class: "acard-value" }
const _hoisted_119 = { class: "acard" }
const _hoisted_120 = { class: "acard-value" }
const _hoisted_121 = { class: "acard" }
const _hoisted_122 = { class: "acard-value" }
const _hoisted_123 = { class: "storage-global-bar-card" }
const _hoisted_124 = { class: "storage-legend" }
const _hoisted_125 = { class: "sleg sleg-files" }
const _hoisted_126 = { class: "sleg sleg-subm" }
const _hoisted_127 = { class: "sleg sleg-media" }
const _hoisted_128 = { class: "sleg sleg-free" }
const _hoisted_129 = { class: "storage-stacked-bar" }
const _hoisted_130 = { class: "analytics-panel storage-table-panel" }
const _hoisted_131 = { class: "storage-table-header" }
const _hoisted_132 = { class: "storage-table-note" }
const _hoisted_133 = { class: "storage-table-wrap" }
const _hoisted_134 = { class: "storage-table" }
const _hoisted_135 = { class: "sort-arrow" }
const _hoisted_136 = { class: "sort-arrow" }
const _hoisted_137 = { class: "sort-arrow" }
const _hoisted_138 = ["onClick"]
const _hoisted_139 = { class: "td-name" }
const _hoisted_140 = { class: "td-site" }
const _hoisted_141 = { class: "td-user" }
const _hoisted_142 = { class: "td-num" }
const _hoisted_143 = { class: "td-num" }
const _hoisted_144 = { class: "td-num" }
const _hoisted_145 = { class: "td-bar" }
const _hoisted_146 = { class: "mini-stacked" }
const _hoisted_147 = { class: "td-num td-muted" }
const _hoisted_148 = { class: "td-num td-muted" }
const _hoisted_149 = { class: "td-num td-muted" }
const _hoisted_150 = {
  key: 0,
  class: "admin-loading"
}
const _hoisted_151 = {
  key: 1,
  class: "admin-loading",
  style: {"color":"#9ca3af"}
}
const _hoisted_152 = {
  key: 2,
  class: "deleted-table"
}
const _hoisted_153 = ["disabled", "onClick"]
const _hoisted_154 = { class: "modal-box" }
const _hoisted_155 = { class: "modal-fields" }
const _hoisted_156 = { class: "modal-field" }
const _hoisted_157 = { class: "modal-field" }
const _hoisted_158 = {
  key: 0,
  class: "modal-error"
}
const _hoisted_159 = {
  key: 1,
  class: "modal-success"
}
const _hoisted_160 = { class: "modal-actions" }
const _hoisted_161 = ["disabled"]
const _hoisted_162 = { class: "modal-box" }
const _hoisted_163 = { class: "modal-fields" }
const _hoisted_164 = { class: "modal-field" }
const _hoisted_165 = { class: "modal-field" }
const _hoisted_166 = { class: "modal-field" }
const _hoisted_167 = { class: "modal-field" }
const _hoisted_168 = { class: "modal-field" }
const _hoisted_169 = ["min", "max"]
const _hoisted_170 = { class: "modal-field" }
const _hoisted_171 = {
  key: 0,
  class: "modal-error"
}
const _hoisted_172 = { class: "modal-actions" }
const _hoisted_173 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Admin2FAModal = _resolveComponent("Admin2FAModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "admin-shell",
    onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.onShellClick && _ctx.onShellClick(...args)))
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _cache[50] || (_cache[50] = _createStaticVNode("<div class=\"admin-nav-left\" data-v-6ca1696e><div class=\"admin-nav-logo\" data-v-6ca1696e><svg width=\"24\" height=\"24\" viewBox=\"0 0 48 48\" fill=\"none\" data-v-6ca1696e><rect width=\"48\" height=\"48\" rx=\"10\" fill=\"rgba(255,255,255,0.15)\" data-v-6ca1696e></rect><path d=\"M24 10L36 18V30L24 38L12 30V18L24 10Z\" fill=\"white\" fill-opacity=\"0.2\" stroke=\"white\" stroke-width=\"2\" data-v-6ca1696e></path><circle cx=\"24\" cy=\"24\" r=\"6\" fill=\"white\" data-v-6ca1696e></circle></svg></div><span class=\"admin-nav-product\" data-v-6ca1696e>Obra Tycoon</span><span class=\"admin-nav-divider\" data-v-6ca1696e></span><span class=\"admin-nav-title\" data-v-6ca1696e>Admin</span></div>", 1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "bell-wrap",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleBell && _ctx.toggleBell(...args)), ["stop"]))
        }, [
          _createElementVNode("button", _hoisted_3, [
            _cache[45] || (_cache[45] = _createElementVNode("svg", {
              width: "18",
              height: "18",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" }),
              _createElementVNode("path", { d: "M13.73 21a2 2 0 01-3.46 0" })
            ], -1)),
            (_ctx.pendingCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.pendingCount), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.bellOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "bell-dropdown",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "bell-dropdown-header" }, "Solicitações de Reativação", -1)),
                (_ctx.reactivationRequests.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Nenhuma solicitação pendente"))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactivationRequests, (req) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: req.id,
                    class: "bell-item"
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(req.siteName || req.systemId), 1),
                    _createElementVNode("div", _hoisted_7, "Por: " + _toDisplayString(req.requestedByUsername) + " · " + _toDisplayString(_ctx.formatDate(req.requestedAt)), 1),
                    (req.message)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(req.message), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "bell-item-btn",
                      type: "button",
                      onClick: ($event: any) => (_ctx.viewSystem(req))
                    }, "Ver obra", 8, _hoisted_9)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString((_ctx.masterSessionStore.state.admin?.name || 'A')[0].toUpperCase()), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.masterSessionStore.state.admin?.name), 1)
        ]),
        _createElementVNode("button", {
          class: "admin-nav-logout",
          type: "button",
          title: "Verificação em duas etapas",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show2fa = true))
        }, [...(_cache[47] || (_cache[47] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" }),
            _createElementVNode("polyline", {
              points: "9 11 12 14 16 9",
              transform: "scale(0.7) translate(5.2 5.2)"
            })
          ], -1),
          _createTextVNode(" 2FA ", -1)
        ]))]),
        _createElementVNode("button", {
          class: "admin-nav-logout",
          type: "button",
          title: "Trocar senha",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openChangePwd && _ctx.openChangePwd(...args)))
        }, [...(_cache[48] || (_cache[48] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("rect", {
              x: "3",
              y: "11",
              width: "18",
              height: "11",
              rx: "2"
            }),
            _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
          ], -1),
          _createTextVNode(" Senha ", -1)
        ]))]),
        _createElementVNode("button", {
          class: "admin-nav-logout",
          type: "button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, [...(_cache[49] || (_cache[49] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" }),
            _createElementVNode("polyline", { points: "16 17 21 12 16 7" }),
            _createElementVNode("line", {
              x1: "21",
              y1: "12",
              x2: "9",
              y2: "12"
            })
          ], -1),
          _createTextVNode(" Sair ", -1)
        ]))])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.changePwd.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cpw-overlay",
            onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeChangePwd && _ctx.closeChangePwd(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_13, [
              _cache[54] || (_cache[54] = _createElementVNode("h3", { class: "cpw-title" }, "Trocar minha senha", -1)),
              _cache[55] || (_cache[55] = _createElementVNode("p", { class: "cpw-sub" }, "Senha do administrador geral. Mínimo 8 caracteres.", -1)),
              _createElementVNode("div", _hoisted_14, [
                _cache[51] || (_cache[51] = _createElementVNode("label", null, "Senha atual", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.changePwd.current) = $event)),
                  type: "password",
                  autocomplete: "current-password"
                }, null, 512), [
                  [_vModelText, _ctx.changePwd.current]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[52] || (_cache[52] = _createElementVNode("label", null, "Nova senha", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.changePwd.next) = $event)),
                  type: "password",
                  autocomplete: "new-password"
                }, null, 512), [
                  [_vModelText, _ctx.changePwd.next]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[53] || (_cache[53] = _createElementVNode("label", null, "Confirmar nova senha", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.changePwd.confirm) = $event)),
                  type: "password",
                  autocomplete: "new-password",
                  onKeyup: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitChangePwd && _ctx.submitChangePwd(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.changePwd.confirm]
                ])
              ]),
              (_ctx.changePwd.error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.changePwd.error), 1))
                : _createCommentVNode("", true),
              (_ctx.changePwd.success)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.changePwd.success), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "cpw-btn cpw-btn--ghost",
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeChangePwd && _ctx.closeChangePwd(...args)))
                }, "Cancelar"),
                _createElementVNode("button", {
                  class: "cpw-btn cpw-btn--primary",
                  type: "button",
                  disabled: _ctx.changePwd.saving,
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submitChangePwd && _ctx.submitChangePwd(...args)))
                }, _toDisplayString(_ctx.changePwd.saving ? 'Salvando...' : 'Alterar senha'), 9, _hoisted_20)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_ctx.show2fa)
      ? (_openBlock(), _createBlock(_component_Admin2FAModal, {
          key: 0,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.show2fa = false)),
          onChanged: () => {}
        }))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.paletteOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "pal-overlay",
            onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePalette && _ctx.closePalette(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[56] || (_cache[56] = _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("circle", {
                    cx: "11",
                    cy: "11",
                    r: "8"
                  }),
                  _createElementVNode("path", { d: "m21 21-4.35-4.35" })
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  ref: "paletteInput",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.paletteQuery) = $event)),
                  type: "text",
                  placeholder: "Ir para obra... (nome ou @username)",
                  onKeydown: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.paletteResults[0] && _ctx.paletteGo(_ctx.paletteResults[0].systemId)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.paletteQuery]
                ]),
                _cache[57] || (_cache[57] = _createElementVNode("kbd", { class: "pal-kbd" }, "Esc", -1))
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paletteResults, (s) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: s.systemId,
                    class: "pal-item",
                    type: "button",
                    onClick: ($event: any) => (_ctx.paletteGo(s.systemId))
                  }, [
                    _createElementVNode("span", {
                      class: "pal-dot",
                      style: _normalizeStyle({ background: s.primaryColor || '#0f4c81' })
                    }, null, 4),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(s.siteName), 1),
                    _createElementVNode("span", _hoisted_26, "@" + _toDisplayString(s.systemUsername), 1),
                    (s.disabled)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, "suspensa"))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_24))
                }), 128)),
                (_ctx.paletteResults.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Nenhuma obra encontrada."))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.kpis.total), 1),
        _cache[58] || (_cache[58] = _createElementVNode("span", { class: "kpi-label" }, "Obras", -1))
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.kpis.ativas), 1),
        _cache[59] || (_cache[59] = _createElementVNode("span", { class: "kpi-label" }, "Ativas", -1))
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("span", {
          class: _normalizeClass(["kpi-value", _ctx.kpis.suspensas > 0 ? 'kpi-value--warn' : ''])
        }, _toDisplayString(_ctx.kpis.suspensas), 3),
        _cache[60] || (_cache[60] = _createElementVNode("span", { class: "kpi-label" }, "Suspensas", -1))
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.kpis.usuarios), 1),
        _cache[61] || (_cache[61] = _createElementVNode("span", { class: "kpi-label" }, "Usuários", -1))
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.kpis.projetos), 1),
        _cache[62] || (_cache[62] = _createElementVNode("span", { class: "kpi-label" }, "Projetos ativos", -1))
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.kpis.usedLabel), 1),
          _createElementVNode("span", _hoisted_42, "de " + _toDisplayString(_ctx.kpis.limitLabel), 1)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", {
            class: "kpi-storage-fill",
            style: _normalizeStyle({ width: _ctx.kpis.storagePct + '%', background: _ctx.kpis.storagePct >= 90 ? '#dc2626' : _ctx.kpis.storagePct >= 70 ? '#f59e0b' : '#16a34a' })
          }, null, 4)
        ]),
        _cache[63] || (_cache[63] = _createElementVNode("span", { class: "kpi-label" }, "Armazenamento total", -1))
      ]),
      _createElementVNode("button", {
        class: "kpi-cmdk",
        type: "button",
        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.openPalette && _ctx.openPalette(...args))),
        title: "Buscar obra (Ctrl+K)"
      }, [...(_cache[64] || (_cache[64] = [
        _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [
          _createElementVNode("circle", {
            cx: "11",
            cy: "11",
            r: "8"
          }),
          _createElementVNode("path", { d: "m21 21-4.35-4.35" })
        ], -1),
        _createTextVNode(" Buscar ", -1),
        _createElementVNode("kbd", null, "Ctrl K", -1)
      ]))])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("button", {
          class: _normalizeClass(["pivot-tab", { active: _ctx.dashTab === 'ativas' }]),
          type: "button",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.dashTab = 'ativas'))
        }, "Obras Ativas", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["pivot-tab", { active: _ctx.dashTab === 'deletadas' }]),
          type: "button",
          onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.loadDeleted(); _ctx.dashTab = 'deletadas'})
        }, "Deletadas", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["pivot-tab", { active: _ctx.dashTab === 'analytics' }]),
          type: "button",
          onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.loadAnalytics(); _ctx.dashTab = 'analytics'})
        }, "Analytics", 2)
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("button", {
          class: "btn-cmd",
          type: "button",
          disabled: _ctx.backupLoading,
          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.downloadBackup && _ctx.downloadBackup(...args)))
        }, [
          _cache[65] || (_cache[65] = _createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
            _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
            _createElementVNode("line", {
              x1: "12",
              y1: "15",
              x2: "12",
              y2: "3"
            })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.backupLoading ? 'Gerando...' : 'Backup'), 1)
        ], 8, _hoisted_47),
        (_ctx.dashTab === 'ativas')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-cmd",
              type: "button",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showImportModal = true))
            }, [...(_cache[66] || (_cache[66] = [
              _createElementVNode("svg", {
                width: "13",
                height: "13",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                _createElementVNode("polyline", { points: "17 8 12 3 7 8" }),
                _createElementVNode("line", {
                  x1: "12",
                  y1: "3",
                  x2: "12",
                  y2: "15"
                })
              ], -1),
              _createTextVNode(" Importar ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.dashTab === 'ativas')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn-cmd-primary",
              type: "button",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showCreateModal = true))
            }, [...(_cache[67] || (_cache[67] = [
              _createElementVNode("svg", {
                width: "13",
                height: "13",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("line", {
                  x1: "12",
                  y1: "5",
                  x2: "12",
                  y2: "19"
                }),
                _createElementVNode("line", {
                  x1: "5",
                  y1: "12",
                  x2: "19",
                  y2: "12"
                })
              ], -1),
              _createTextVNode(" Nova Obra ", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("main", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        (_ctx.dashTab === 'ativas')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_50, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  class: "admin-search",
                  type: "text",
                  placeholder: "Buscar obra por nome ou username..."
                }, null, 512), [
                  [_vModelText, _ctx.searchQuery]
                ])
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, "Carregando obras..."))
                : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSystems, (s) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: s.systemId,
                        class: _normalizeClass(["obra-card", { disabled: s.disabled }]),
                        onClick: ($event: any) => (_ctx.goToSystem(s.systemId))
                      }, [
                        _createElementVNode("div", {
                          class: "obra-card-header",
                          style: _normalizeStyle({ background: s.primaryColor || '#0f4c81' })
                        }, [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(s.siteName), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["obra-card-badge", s.disabled ? 'badge-off' : 'badge-on'])
                          }, _toDisplayString(s.disabled ? 'Inativo' : 'Ativo'), 3)
                        ], 4),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("span", _hoisted_58, _toDisplayString(s.activeUsers), 1),
                              _cache[68] || (_cache[68] = _createElementVNode("span", { class: "obra-stat-label" }, "Usuários ativos", -1))
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("span", _hoisted_60, _toDisplayString(s.inactiveUsers), 1),
                              _cache[69] || (_cache[69] = _createElementVNode("span", { class: "obra-stat-label" }, "Inativos", -1))
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("span", _hoisted_62, _toDisplayString(s.activeProjects), 1),
                              _cache[70] || (_cache[70] = _createElementVNode("span", { class: "obra-stat-label" }, "Projetos", -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", {
                                class: "obra-storage-bar-fill",
                                style: _normalizeStyle({ width: Math.min(100, (s.usedMb / s.storageLimitMb) * 100) + '%', background: _ctx.storageColor(s.usedMb, s.storageLimitMb) })
                              }, null, 4)
                            ]),
                            _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.formatMb(s.usedMb)) + " / " + _toDisplayString(_ctx.formatMb(s.storageLimitMb)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _cache[71] || (_cache[71] = _createElementVNode("span", { class: "obra-date-label" }, "Início", -1)),
                              _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.formatDate(s.createdAt)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _cache[72] || (_cache[72] = _createElementVNode("span", { class: "obra-date-label" }, "Renovação", -1)),
                              _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.formatDate(s.renewalDate) || '—'), 1)
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "obra-card-actions",
                            onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("button", {
                              class: "btn-obra-export",
                              type: "button",
                              disabled: _ctx.exportLoading === s.systemId,
                              onClick: _withModifiers(($event: any) => (_ctx.exportObra(s)), ["stop"])
                            }, [
                              _cache[73] || (_cache[73] = _createElementVNode("svg", {
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                                _createElementVNode("line", {
                                  x1: "12",
                                  y1: "15",
                                  x2: "12",
                                  y2: "3"
                                })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.exportLoading === s.systemId ? 'Exportando...' : 'Exportar ZIP'), 1)
                            ], 8, _hoisted_71)
                          ])
                        ])
                      ], 10, _hoisted_53))
                    }), 128))
                  ]))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.dashTab === 'analytics')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("button", {
                  class: _normalizeClass(["asubtab", { active: _ctx.analyticsSubTab === 'geral' }]),
                  type: "button",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.switchAnalyticsTab('geral')))
                }, " Visão geral ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["asubtab", { active: _ctx.analyticsSubTab === 'consumo' }]),
                  type: "button",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.switchAnalyticsTab('consumo')))
                }, " Consumo ", 2)
              ]),
              (_ctx.analyticsSubTab === 'geral')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.analyticsLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, "Carregando analytics..."))
                      : (_ctx.analytics)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.analytics.totalSystems), 1),
                                _cache[74] || (_cache[74] = _createElementVNode("span", { class: "acard-label" }, "Obras totais", -1))
                              ]),
                              _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.analytics.activeSystems), 1),
                                _cache[75] || (_cache[75] = _createElementVNode("span", { class: "acard-label" }, "Obras ativas", -1))
                              ]),
                              _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.analytics.suspendedSystems), 1),
                                _cache[76] || (_cache[76] = _createElementVNode("span", { class: "acard-label" }, "Suspensas", -1))
                              ]),
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.analytics.totalUsers), 1),
                                _cache[77] || (_cache[77] = _createElementVNode("span", { class: "acard-label" }, "Usuários", -1))
                              ]),
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.analytics.totalProjects), 1),
                                _cache[78] || (_cache[78] = _createElementVNode("span", { class: "acard-label" }, "Projetos", -1))
                              ]),
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.analytics.totalSubmissions), 1),
                                _cache[79] || (_cache[79] = _createElementVNode("span", { class: "acard-label" }, "Relatórios", -1))
                              ]),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.formatMb(_ctx.analytics.totalFileMb)), 1),
                                _cache[80] || (_cache[80] = _createElementVNode("span", { class: "acard-label" }, "Arquivos", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("div", _hoisted_91, [
                                _cache[81] || (_cache[81] = _createElementVNode("h3", { class: "analytics-panel-title" }, "Ranking por usuários", -1)),
                                _createElementVNode("div", _hoisted_92, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analytics.topByUsers, (s, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: s.systemId,
                                      class: "rank-row",
                                      onClick: ($event: any) => (_ctx.goToSystem(s.systemId))
                                    }, [
                                      _createElementVNode("span", _hoisted_94, "#" + _toDisplayString(i + 1), 1),
                                      _createElementVNode("span", _hoisted_95, _toDisplayString(s.siteName), 1),
                                      _createElementVNode("span", _hoisted_96, _toDisplayString(s.userCount) + " usuários", 1)
                                    ], 8, _hoisted_93))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_97, [
                                _cache[82] || (_cache[82] = _createElementVNode("h3", { class: "analytics-panel-title" }, "Ranking por atividade (mês atual)", -1)),
                                _createElementVNode("div", _hoisted_98, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analytics.topByActivity, (s, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: s.systemId,
                                      class: "rank-row",
                                      onClick: ($event: any) => (_ctx.goToSystem(s.systemId))
                                    }, [
                                      _createElementVNode("span", _hoisted_100, "#" + _toDisplayString(i + 1), 1),
                                      _createElementVNode("span", _hoisted_101, _toDisplayString(s.siteName), 1),
                                      _createElementVNode("span", _hoisted_102, _toDisplayString(s.submissionCount) + " relatórios", 1)
                                    ], 8, _hoisted_99))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_103, [
                                _cache[83] || (_cache[83] = _createElementVNode("h3", { class: "analytics-panel-title" }, "Renovações nos próximos 30 dias", -1)),
                                (_ctx.analytics.expiringRenewals.length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, "Nenhuma renovação nos próximos 30 dias."))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_105, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analytics.expiringRenewals, (s) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: s.systemId,
                                      class: "rank-row rank-row-warn",
                                      onClick: ($event: any) => (_ctx.goToSystem(s.systemId))
                                    }, [
                                      _createElementVNode("span", _hoisted_107, _toDisplayString(s.siteName), 1),
                                      _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.formatDate(s.renewalDate)), 1)
                                    ], 8, _hoisted_106))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ], 64))
                : (_ctx.analyticsSubTab === 'consumo')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.storageLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, "Carregando dados de consumo..."))
                        : (_ctx.storageOverview)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                              _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("div", _hoisted_112, [
                                  _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.formatMb(_ctx.storageOverview.totalUsedMb)), 1),
                                  _cache[84] || (_cache[84] = _createElementVNode("span", { class: "acard-label" }, "Total utilizado", -1))
                                ]),
                                _createElementVNode("div", _hoisted_114, [
                                  _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.formatMb(_ctx.storageOverview.totalLimitMb)), 1),
                                  _cache[85] || (_cache[85] = _createElementVNode("span", { class: "acard-label" }, "Capacidade total", -1))
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["acard", _ctx.storageOverview.totalPct >= 80 ? 'acard-danger' : _ctx.storageOverview.totalPct >= 60 ? 'acard-warn' : ''])
                                }, [
                                  _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.storageOverview.totalPct) + "%", 1),
                                  _cache[86] || (_cache[86] = _createElementVNode("span", { class: "acard-label" }, "Ocupação global", -1))
                                ], 2),
                                _createElementVNode("div", _hoisted_117, [
                                  _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.formatMb(_ctx.storageOverview.filesMb)), 1),
                                  _cache[87] || (_cache[87] = _createElementVNode("span", { class: "acard-label" }, "Arquivos de projeto", -1))
                                ]),
                                _createElementVNode("div", _hoisted_119, [
                                  _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.formatMb(_ctx.storageOverview.submMb)), 1),
                                  _cache[88] || (_cache[88] = _createElementVNode("span", { class: "acard-label" }, "Relatórios", -1))
                                ]),
                                _createElementVNode("div", _hoisted_121, [
                                  _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.formatMb(_ctx.storageOverview.mediaMb)), 1),
                                  _cache[89] || (_cache[89] = _createElementVNode("span", { class: "acard-label" }, "Mídias (fotos)", -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_123, [
                                _cache[90] || (_cache[90] = _createElementVNode("div", { class: "storage-global-title" }, "Distribuição global do armazenamento", -1)),
                                _createElementVNode("div", _hoisted_124, [
                                  _createElementVNode("span", _hoisted_125, "Arquivos — " + _toDisplayString(_ctx.formatMb(_ctx.storageOverview.filesMb)), 1),
                                  _createElementVNode("span", _hoisted_126, "Relatórios — " + _toDisplayString(_ctx.formatMb(_ctx.storageOverview.submMb)), 1),
                                  _createElementVNode("span", _hoisted_127, "Mídias — " + _toDisplayString(_ctx.formatMb(_ctx.storageOverview.mediaMb)), 1),
                                  _createElementVNode("span", _hoisted_128, "Livre — " + _toDisplayString(_ctx.formatMb(Math.max(0, _ctx.storageOverview.totalLimitMb - _ctx.storageOverview.totalUsedMb))), 1)
                                ]),
                                _createElementVNode("div", _hoisted_129, [
                                  _createElementVNode("div", {
                                    class: "ssb-seg ssb-files",
                                    style: _normalizeStyle({ width: (_ctx.storageOverview.totalLimitMb > 0 ? _ctx.storageOverview.filesMb / _ctx.storageOverview.totalLimitMb * 100 : 0) + '%' })
                                  }, null, 4),
                                  _createElementVNode("div", {
                                    class: "ssb-seg ssb-subm",
                                    style: _normalizeStyle({ width: (_ctx.storageOverview.totalLimitMb > 0 ? _ctx.storageOverview.submMb  / _ctx.storageOverview.totalLimitMb * 100 : 0) + '%' })
                                  }, null, 4),
                                  _createElementVNode("div", {
                                    class: "ssb-seg ssb-media",
                                    style: _normalizeStyle({ width: (_ctx.storageOverview.totalLimitMb > 0 ? _ctx.storageOverview.mediaMb / _ctx.storageOverview.totalLimitMb * 100 : 0) + '%' })
                                  }, null, 4)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_130, [
                                _createElementVNode("div", _hoisted_131, [
                                  _cache[91] || (_cache[91] = _createElementVNode("h3", {
                                    class: "analytics-panel-title",
                                    style: {"margin":"0"}
                                  }, "Consumo por obra", -1)),
                                  _createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.storageOverview.systems.length) + " obras", 1)
                                ]),
                                _createElementVNode("div", _hoisted_133, [
                                  _createElementVNode("table", _hoisted_134, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", {
                                          class: "th-sort",
                                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.toggleStorageSort('siteName')))
                                        }, [
                                          _cache[92] || (_cache[92] = _createTextVNode(" Obra ", -1)),
                                          _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.storageSortField === 'siteName' ? (_ctx.storageSortDir === 'asc' ? '↑' : '↓') : '↕'), 1)
                                        ]),
                                        _createElementVNode("th", {
                                          class: "th-sort th-num",
                                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.toggleStorageSort('usedMb')))
                                        }, [
                                          _cache[93] || (_cache[93] = _createTextVNode(" Usado ", -1)),
                                          _createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.storageSortField === 'usedMb' ? (_ctx.storageSortDir === 'asc' ? '↑' : '↓') : '↕'), 1)
                                        ]),
                                        _cache[95] || (_cache[95] = _createElementVNode("th", { class: "th-num" }, "Limite", -1)),
                                        _createElementVNode("th", {
                                          class: "th-sort th-num",
                                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.toggleStorageSort('pct')))
                                        }, [
                                          _cache[94] || (_cache[94] = _createTextVNode(" % ", -1)),
                                          _createElementVNode("span", _hoisted_137, _toDisplayString(_ctx.storageSortField === 'pct' ? (_ctx.storageSortDir === 'asc' ? '↑' : '↓') : '↕'), 1)
                                        ]),
                                        _cache[96] || (_cache[96] = _createElementVNode("th", null, "Distribuição", -1)),
                                        _cache[97] || (_cache[97] = _createElementVNode("th", { class: "th-num" }, "Arquivos", -1)),
                                        _cache[98] || (_cache[98] = _createElementVNode("th", { class: "th-num" }, "Relatórios", -1)),
                                        _cache[99] || (_cache[99] = _createElementVNode("th", { class: "th-num" }, "Mídias", -1))
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storageSorted, (s) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: s.systemId,
                                          class: "storage-tr",
                                          onClick: ($event: any) => (_ctx.goToSystem(s.systemId))
                                        }, [
                                          _createElementVNode("td", _hoisted_139, [
                                            _createElementVNode("span", _hoisted_140, _toDisplayString(s.siteName), 1),
                                            _createElementVNode("span", _hoisted_141, "@" + _toDisplayString(s.systemUsername), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_142, _toDisplayString(_ctx.formatMb(s.usedMb)), 1),
                                          _createElementVNode("td", _hoisted_143, _toDisplayString(_ctx.formatMb(s.limitMb)), 1),
                                          _createElementVNode("td", _hoisted_144, [
                                            _createElementVNode("span", {
                                              class: "pct-badge",
                                              style: _normalizeStyle({ background: _ctx.storageBarColor(s.pct) + '22', color: _ctx.storageBarColor(s.pct) })
                                            }, _toDisplayString(s.pct) + "% ", 5)
                                          ]),
                                          _createElementVNode("td", _hoisted_145, [
                                            _createElementVNode("div", _hoisted_146, [
                                              _createElementVNode("div", {
                                                class: "ssb-seg ssb-files",
                                                style: _normalizeStyle({ width: (s.limitMb > 0 ? s.filesMb / s.limitMb * 100 : 0) + '%' })
                                              }, null, 4),
                                              _createElementVNode("div", {
                                                class: "ssb-seg ssb-subm",
                                                style: _normalizeStyle({ width: (s.limitMb > 0 ? s.submMb  / s.limitMb * 100 : 0) + '%' })
                                              }, null, 4),
                                              _createElementVNode("div", {
                                                class: "ssb-seg ssb-media",
                                                style: _normalizeStyle({ width: (s.limitMb > 0 ? s.mediaMb / s.limitMb * 100 : 0) + '%' })
                                              }, null, 4)
                                            ])
                                          ]),
                                          _createElementVNode("td", _hoisted_147, _toDisplayString(_ctx.formatMb(s.filesMb)), 1),
                                          _createElementVNode("td", _hoisted_148, _toDisplayString(_ctx.formatMb(s.submMb)), 1),
                                          _createElementVNode("td", _hoisted_149, _toDisplayString(_ctx.formatMb(s.mediaMb)), 1)
                                        ], 8, _hoisted_138))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.dashTab === 'deletadas')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_ctx.deletedLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_150, "Carregando..."))
                : (_ctx.deletedSystems.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, "Nenhuma obra deletada."))
                  : (_openBlock(), _createElementBlock("table", _hoisted_152, [
                      _cache[100] || (_cache[100] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Nome da obra"),
                          _createElementVNode("th", null, "Username"),
                          _createElementVNode("th", null, "Usuários"),
                          _createElementVNode("th", null, "Projetos"),
                          _createElementVNode("th", null, "Dados"),
                          _createElementVNode("th", null, "Deletada em"),
                          _createElementVNode("th")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deletedSystems, (d) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: d.systemId
                          }, [
                            _createElementVNode("td", null, _toDisplayString(d.siteName), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("code", null, _toDisplayString(d.originalSystemUsername), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(d.totalUsers), 1),
                            _createElementVNode("td", null, _toDisplayString(d.totalProjects), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatMb(d.usedMb)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(d.deletedAt)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "btn-recover",
                                type: "button",
                                disabled: _ctx.recoveringId === d.systemId,
                                onClick: ($event: any) => (_ctx.recoverSystem(d))
                              }, _toDisplayString(_ctx.recoveringId === d.systemId ? 'Recuperando...' : 'Recuperar obra'), 9, _hoisted_153)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showImportModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal-overlay",
          onClick: _cache[34] || (_cache[34] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeImportModal && _ctx.closeImportModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_154, [
            _cache[103] || (_cache[103] = _createElementVNode("h2", { class: "modal-title" }, "Importar obra", -1)),
            _createElementVNode("div", _hoisted_155, [
              _createElementVNode("div", _hoisted_156, [
                _cache[101] || (_cache[101] = _createElementVNode("label", null, "Arquivo ZIP da obra", -1)),
                _createElementVNode("input", {
                  type: "file",
                  accept: ".zip",
                  onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.onImportFile && _ctx.onImportFile(...args)))
                }, null, 32)
              ]),
              _createElementVNode("div", _hoisted_157, [
                _cache[102] || (_cache[102] = _createElementVNode("label", null, "Novo username da obra (só letras minúsculas)", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.importUsername) = $event)),
                  type: "text",
                  placeholder: "Ex.: novaobra"
                }, null, 512), [
                  [_vModelText, _ctx.importUsername]
                ])
              ])
            ]),
            (_ctx.importError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_158, _toDisplayString(_ctx.importError), 1))
              : _createCommentVNode("", true),
            (_ctx.importSuccess)
              ? (_openBlock(), _createElementBlock("p", _hoisted_159, _toDisplayString(_ctx.importSuccess), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_160, [
              _createElementVNode("button", {
                class: "btn-admin-ghost",
                type: "button",
                onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.closeImportModal && _ctx.closeImportModal(...args)))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn-admin-primary",
                type: "button",
                disabled: _ctx.importing,
                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.handleImport && _ctx.handleImport(...args)))
              }, _toDisplayString(_ctx.importing ? 'Importando...' : 'Importar'), 9, _hoisted_161)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCreateModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "modal-overlay",
          onClick: _cache[43] || (_cache[43] = _withModifiers(($event: any) => (_ctx.showCreateModal = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_162, [
            _cache[110] || (_cache[110] = _createElementVNode("h2", { class: "modal-title" }, "Nova Obra", -1)),
            _createElementVNode("div", _hoisted_163, [
              _createElementVNode("div", _hoisted_164, [
                _cache[104] || (_cache[104] = _createElementVNode("label", null, "Nome da obra", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.newSiteName) = $event)),
                  type: "text",
                  placeholder: "Ex.: Obra Sul 2026"
                }, null, 512), [
                  [_vModelText, _ctx.newSiteName]
                ])
              ]),
              _createElementVNode("div", _hoisted_165, [
                _cache[105] || (_cache[105] = _createElementVNode("label", null, "Username da obra (só letras minúsculas)", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.newSystemUsername) = $event)),
                  type: "text",
                  placeholder: "Ex.: obrasul"
                }, null, 512), [
                  [_vModelText, _ctx.newSystemUsername]
                ])
              ]),
              _createElementVNode("div", _hoisted_166, [
                _cache[106] || (_cache[106] = _createElementVNode("label", null, "Nome do administrador", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.newAdminName) = $event)),
                  type: "text",
                  placeholder: "Ex.: Ana Souza"
                }, null, 512), [
                  [_vModelText, _ctx.newAdminName]
                ])
              ]),
              _createElementVNode("div", _hoisted_167, [
                _cache[107] || (_cache[107] = _createElementVNode("label", null, "Username do administrador", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.newAdminUsername) = $event)),
                  type: "text",
                  placeholder: "Ex.: ana"
                }, null, 512), [
                  [_vModelText, _ctx.newAdminUsername]
                ])
              ]),
              _createElementVNode("div", _hoisted_168, [
                _cache[108] || (_cache[108] = _createElementVNode("label", null, "Data de nascimento do administrador", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.newAdminBirthDate) = $event)),
                  type: "date",
                  min: _ctx.MIN_BIRTH_DATE,
                  max: _ctx.maxBirthDate()
                }, null, 8, _hoisted_169), [
                  [_vModelText, _ctx.newAdminBirthDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_170, [
                _cache[109] || (_cache[109] = _createElementVNode("label", null, "Senha do administrador", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.newAdminPassword) = $event)),
                  type: "password",
                  placeholder: "••••••"
                }, null, 512), [
                  [_vModelText, _ctx.newAdminPassword]
                ])
              ])
            ]),
            (_ctx.createError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_171, _toDisplayString(_ctx.createError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_172, [
              _createElementVNode("button", {
                class: "btn-admin-ghost",
                type: "button",
                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.showCreateModal = false))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn-admin-primary",
                type: "button",
                disabled: _ctx.creating,
                onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.createSystem && _ctx.createSystem(...args)))
              }, _toDisplayString(_ctx.creating ? 'Criando...' : 'Criar obra'), 9, _hoisted_173)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}